import { render, staticRenderFns } from "./breed_waterManage_page.vue?vue&type=template&id=374130c8&scoped=true"
import script from "./breed_waterManage_page.vue?vue&type=script&lang=js"
export * from "./breed_waterManage_page.vue?vue&type=script&lang=js"
import style0 from "./breed_waterManage_page.vue?vue&type=style&index=0&id=374130c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374130c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374130c8')) {
      api.createRecord('374130c8', component.options)
    } else {
      api.reload('374130c8', component.options)
    }
    module.hot.accept("./breed_waterManage_page.vue?vue&type=template&id=374130c8&scoped=true", function () {
      api.rerender('374130c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_waterManage_page.vue"
export default component.exports